import "./CircleSlider.css";

const CircleSlider = ({ currentStep }) => {

  return (
    <div className="container-slider">
      <div className={`circle-slider ${currentStep === 0 ? "circle-slider-print" : "circle-slider"}`}></div>
      <div className={`circle-slider ${currentStep === 1 ? "circle-slider-print" : "circle-slider"}`}></div>
      <div className={`circle-slider ${currentStep === 2 ? "circle-slider-print" : "circle-slider"}`}></div>
    </div>
  );
};

export default CircleSlider;
